import {useState} from "react";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {PostCardDropDownProps} from "../../types/ComponentProps";
import PostCardStyles from "./PostCardStyles.module.css";
import deletePost from "../../api/deletePost";
import useGetPostById from "../../hooks/useGetPostById";
import {usePostForm} from "../../context/PostFormContext";
import {useModal} from "../../context/ModalContext";

const PostCardDropDown = ({
  postId,
  setEditPostModal,
  setEditCardSelection,
}: PostCardDropDownProps) => {
  const {setPostLoading: setDeleteLoading} = usePostForm();
  const queryClient = useQueryClient();
  const {getPostByIdData} = useGetPostById(postId);
  const [showDropDown, setShowDropDown] = useState<boolean>(false);
  const {openModal, closeModal} = useModal();

  const deletePostMutation = useMutation({
    mutationFn: () => deletePost(postId),
    onSuccess: async () => {
      try {
        await queryClient.invalidateQueries({queryKey: ["getAllPosts"]});
        await queryClient.invalidateQueries({queryKey: ["getAllPostsById"]});
      } catch (error) {
        console.error("Error invalidating queries:", error);
      } finally {
        setDeleteLoading(false);
        closeModal();
      }
    },
    onError: (error: Error) => {
      setDeleteLoading(false);
    },
  });

  const onClickHandler = () => {
    setShowDropDown((prev) => !prev);
  };

  const onEditHandler = () => {
    if (setEditPostModal && setEditCardSelection) {
      setEditCardSelection(postId);
      setEditPostModal(true);
    }
  };

  const onDeleteHandler = async () => {
    setDeleteLoading(true);
    deletePostMutation.mutate();
  };

  const openDeleteModal = () => {
    openModal("Are you sure you want to delete?", onDeleteHandler);
  };
  return (
    <div
      onMouseLeave={() => setShowDropDown(false)}
      className={PostCardStyles.dropDownContainer}>
      {showDropDown && (
        <div className={PostCardStyles.dropDownBlk}>
          {!getPostByIdData?.post?.badgeId && (
            <p className={PostCardStyles.editButton} onClick={onEditHandler}>
              Edit
            </p>
          )}
          <p className={PostCardStyles.deleteButton} onClick={openDeleteModal}>
            Delete
          </p>
        </div>
      )}

      <i
        className={`${PostCardStyles.ellipsisBlk} fa-solid fa-ellipsis`}
        onClick={onClickHandler}
      />
    </div>
  );
};

export default PostCardDropDown;
